import { ManagerError } from '@new/common/utils/error-parser';
import { type Pools } from '../../lib/types';

export class LoadPools {
  public static readonly type = '[Pools] Load';
}

export class LoadPoolsSuccess {
  public static readonly type = '[Pools] Load Success';
  constructor(public readonly pools: Pools) {}
}

export class LoadPoolsFailure {
  public static readonly type = '[Pools] Load Failure';
  constructor(public readonly error: ManagerError) {}
}
